export default theme => ({
  root: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  label: {
    color: "rgba(0, 0, 0, 0.54)"
  },
  button: {
    backgroundColor: "rgb(167, 175, 124)",
    border: "1px solid rgba(30, 133, 69, 0.5)",
    "&:hover": {
      background: "rgb(245, 248, 228)",
      color: "white"
    }
  },
  buttonCancel: {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    border: "1px solid rgba(30, 133, 69, 0.5)",
    "&:hover": {
      background: "rgb(245, 248, 228)",
      color: "white"
    }
  }
});
